<div class="card bg-primary-600 flex">
  <div class="p-4 ml-4 flex-none self-center hidden sm:block">
    <img
      src="../../../../../../assets/img/illustrations/checklist.svg"
      style="height: 168px; width: 152px" />
  </div>

  <div class="p-6 text-on-primary-600 flex-auto">
    <h2 class="headline m-0">Good Job, David!</h2>
    <p class="caption m-0 opacity-50">
      You've finished all of your tasks for this week.
    </p>

    <div class="mt-4 flex items-center">
      <mat-icon class="mr-2" svgIcon="mat:check_circle"></mat-icon>
      <span class="body-2 cursor-pointer">Finish Dashboard Design</span>
    </div>

    <div class="mt-1 flex items-center">
      <mat-icon class="mr-2" svgIcon="mat:check_circle"></mat-icon>
      <span class="body-2 cursor-pointer">Fix Issue #74</span>
    </div>

    <div class="mt-1 flex items-center">
      <mat-icon class="mr-2" svgIcon="mat:check_circle"></mat-icon>
      <span class="body-2 cursor-pointer">Publish version 2.3.3</span>
    </div>
  </div>
</div>
